var map = {
	"./ArrowIcon.svg": 63594,
	"./CVAT.png": 42240,
	"./Ellipse 65.svg": 22775,
	"./FreeUserStar.svg": 40949,
	"./Moondream_logo.svg": 38940,
	"./Rectangle-new.svg": 61956,
	"./S3-upload.svg": 83158,
	"./VL-Beta-Logo.svg": 10789,
	"./Vector239.svg": 70695,
	"./VectorLogo.svg": 8954,
	"./account-tree-menu-open.svg": 5529,
	"./allen_ai_logo.svg": 32547,
	"./anonymous_user.svg": 22401,
	"./arrow.svg": 52013,
	"./arrowDown.svg": 18057,
	"./arrowUp.svg": 59526,
	"./arrow_back.svg": 67993,
	"./arrow_right_rectangle.svg": 90628,
	"./auto-renew.svg": 78463,
	"./avatar.svg": 57953,
	"./bigImg.svg": 46585,
	"./bin.svg": 15037,
	"./blank.png": 36752,
	"./blue-cross-icon.svg": 34981,
	"./camera.svg": 23755,
	"./card-image.svg": 47524,
	"./chat.svg": 71660,
	"./chatOpenGo.svg": 79350,
	"./check-circle.svg": 89451,
	"./chevron copy.svg": 83074,
	"./chevron.svg": 91943,
	"./clockIcon.svg": 18359,
	"./cloud-white.svg": 95049,
	"./cloud.svg": 46965,
	"./cluster-inventory-logo.svg": 94333,
	"./cluster-sizing-icon-big.svg": 59198,
	"./cluster-sizing-icon-small.svg": 63225,
	"./clusterLogo.svg": 8265,
	"./colored-file-storage.svg": 92763,
	"./colored-setting.svg": 2867,
	"./colored-to-do-list.svg": 47381,
	"./cross.svg": 90190,
	"./crossImg.svg": 61139,
	"./danger.svg": 89307,
	"./dataInventoryResume.svg": 94459,
	"./dataset.svg": 31886,
	"./dateCreated.svg": 36734,
	"./deepseek_logo.svg": 37494,
	"./deleteDataset.svg": 23417,
	"./download-icon-black.svg": 57234,
	"./download-icon-white.svg": 86328,
	"./download-loader.gif": 55533,
	"./edit.svg": 69338,
	"./ellipseBlack.svg": 66073,
	"./ellipseWhite.svg": 83343,
	"./eye.svg": 85297,
	"./failed.svg": 80353,
	"./fancy-right-arrow.svg": 10268,
	"./filter-menu-open.svg": 50917,
	"./filter.svg": 79500,
	"./filter_2.svg": 44955,
	"./fix.svg": 42703,
	"./folder.svg": 90006,
	"./freePlan.svg": 8537,
	"./github-logo.svg": 80577,
	"./google-logo.svg": 63905,
	"./googleIcon.svg": 36052,
	"./gpt_symbol.svg": 11688,
	"./grayBorderCircle.svg": 96705,
	"./greenTick.svg": 90388,
	"./grey-info-icon.svg": 78590,
	"./grid.svg": 26374,
	"./group-users.svg": 36184,
	"./group.svg": 25055,
	"./hurrah-image.svg": 90484,
	"./imageTab.svg": 95674,
	"./indexing.svg": 26406,
	"./layers-magic.svg": 91562,
	"./line_view.svg": 74416,
	"./lion-3626.svg": 65910,
	"./lion-body.svg": 19201,
	"./lion-face.svg": 80494,
	"./lion-front.svg": 1238,
	"./lion-hover.svg": 41017,
	"./lion-skin.svg": 75814,
	"./lion-sleep.svg": 15930,
	"./local_upload.svg": 6469,
	"./lock.svg": 91447,
	"./log_out.svg": 82797,
	"./login-vllogo.svg": 31121,
	"./logout.svg": 63292,
	"./magnifying-glass.svg": 27882,
	"./maxAmountDataset.svg": 27632,
	"./media.svg": 35150,
	"./menu-open.svg": 3696,
	"./message.svg": 80051,
	"./minus.svg": 8682,
	"./modalBlackCross.svg": 79198,
	"./nest-wifi-route-white.svg": 89498,
	"./nest-wifi-router.svg": 80928,
	"./newVLicon.svg": 95457,
	"./no-results-icon.svg": 90128,
	"./no-search.svg": 12888,
	"./nvidia_symbol.svg": 25234,
	"./open_gv_lab.png": 76586,
	"./ovis2.svg": 16173,
	"./pencil-icon.svg": 72409,
	"./placeholder-image.svg": 91297,
	"./plane.svg": 23156,
	"./plus-black.svg": 35376,
	"./plus.svg": 84034,
	"./preview-info-icon.svg": 98367,
	"./privateIcon.svg": 54204,
	"./pro-plan.svg": 15021,
	"./publicIcon.svg": 6070,
	"./qwen_logo.svg": 22015,
	"./radioButtonIcon.svg": 95904,
	"./ready.svg": 87379,
	"./rocket.svg": 71630,
	"./scan.svg": 45413,
	"./search.svg": 12054,
	"./size.svg": 47705,
	"./something-went-wrong-icon.svg": 56425,
	"./square-plane.svg": 51570,
	"./star.svg": 96822,
	"./star_without_bg.svg": 88559,
	"./subtract.svg": 3890,
	"./tag-icon-black.svg": 54138,
	"./tag-icon.svg": 64368,
	"./timeline.svg": 4371,
	"./timelineIcon.svg": 53364,
	"./trash.svg": 90008,
	"./tuneIcon.svg": 37607,
	"./union.svg": 17611,
	"./upload-dataset.svg": 99682,
	"./upload-icon.svg": 63833,
	"./upload-purple.svg": 32316,
	"./upload.svg": 24341,
	"./uploading.svg": 38379,
	"./user.svg": 32751,
	"./users2.svg": 43712,
	"./vector-menu-open.svg": 7454,
	"./vector-white.svg": 70483,
	"./vector.svg": 98259,
	"./visual-layer-text-logo.svg": 69298,
	"./vl-cloud-title.svg": 28009,
	"./vllogo-with-label.svg": 34455,
	"./vllogo.svg": 25317,
	"./zoom-control.svg": 50267
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;